module.exports = __webpack_public_path__ + "57888be7f3e68a7050452ea3157cf4de.svg";